import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CommsService } from '../comms/comms.service';
import { DataService } from '../data/data.service';
import { NoteService } from '../note/note.service';
import { ConfigService } from '../config/config.service';
import { DisplayService } from '../display/display.service';
import { ContractorService } from '../contractor/contractor.service';
import { InvoiceService } from '../invoice/invoice.service';
import { TabService } from '../tab/tab.service';
import { DataTableService } from '../dataTable/dataTable.service';

import _ from 'lodash';

@Injectable()
export class PurchaseOrderService {

	dataObj = 'purchaseorder';
	dataConfig = {};

	pendingDataObj = '';

	objString = 'Purchase Orders';
	listRoot = 'purchase-orders';
	objRoot = 'purchase-order';
	straighttimeKey = '00001';

	tabsData = {
		tabs: [
			{
				prop: 'details',
				name: 'Details',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'contractors',
				name: 'Contractor Line Items',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		listTabs: [
			{
				prop: 'nocontractors',
				name: 'Pending Contractor Assignment',
				active: false,
				persona: ['pm', 'sam', 'cca', 'readonly'],
				notPersona: [],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'any',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'unarchive',
				name: 'Primary',
				active: false,
				persona: ['all'],
				notPersona: ['cca'],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'undelegated',
				name: 'Non-Delegated',
				active: false,
				persona: ['cca'],
				notPersona: [],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'delegated',
				name: 'Delegated',
				active: false,
				persona: ['cca'],
				notPersona: [],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'archive',
				name: 'Inactive',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'cancellation',
				name: 'Cancelled',
				active: false,
				persona: ['pm', 'sam', 'cca', 'readonly', 'fa'],
				notPersona: [],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'renewals',
				name: 'Expiring',
				active: false,
				persona: ['pm', 'sam'],
				notPersona: [],
				cached: false,
				listTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		]
	};

	activeTab;
	poNumber;
	supplierId;
	activePanels = '';
	selectedPO;

	showMergeModal = false;

	errorDataObj = 'purchaseordererror';
	successDataObj = 'purchaseordersuccess';
	showErrorPOs = false;
	showSuccessPOs = false;

	constructor(
		private router: Router,
		private commsService: CommsService,
		private dataService: DataService,
		private noteService: NoteService,
		private configService: ConfigService,
		private displayService: DisplayService,
		private contractorService: ContractorService,
		private invoiceService: InvoiceService,
		private tabService: TabService,
		private dataTableService: DataTableService
	) { }


	// TABBING METHODS

	getActiveTab(tabsData): any {
		let activeTab: any = {};
		tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp, tabsData, type) {
		console.log('TAB CLICK', event, tabProp, tabsData);
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					window.history.replaceState({}, '', '/purchase-orders/' + tabProp);
					self.loadPOsForTab(d);
				}
			}
		});
	}

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			console.log('CHECK TAB FOR DEFAULT', d, self.tabService.showTab(d.persona, d.notPersona));
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				if (d.listTab) {
					self.loadPOsForTab(d);
				}
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				self.loadPOsForTab(d);
			}
		});
	}

	showTabSearch(tabsData) {
		this.getActiveTab(tabsData)['searching'] = !this.getActiveTab(tabsData)['searching'];
	}

	checkTabs(tabsData) {
		// expected method, no logic needed for po page tabs
		// see same method in contractorService for example of use
	}

	loadPOsForAllTabs() {
		const self = this;
		this.tabsData.listTabs.forEach(tab => {
			if (self.tabService.showTab(tab.persona, tab.notPersona)) {
				self.loadPOs(tab);
			}
		});
	}

	loadAllforTab(tab) {
		if (tab.listTab) {
			this.downloadPOsForTab(tab);
		}
	}

	loadPOsForTab(tab) {
		console.log('LOAD POS FOR TAB', tab);
		this.loadPOs(tab);
	}


	// UI INTERACTIONS

	openPO(poNumber, supplierId) {
		this.poNumber = poNumber;
		this.supplierId = supplierId;
		this.router.navigateByUrl(this.objRoot + '/' + poNumber + '/' + supplierId);
	}

	openPOContractor(poNumber, contractorId, supplierId) {
		this.loadPOContractor(poNumber, contractorId, supplierId);
		console.log('OPEN PO CONTRACTOR: ', this.dataService.selectedTableRows);
	}

	tableClick(event) {
		console.log('PO TABLE CLICK: ', event);
		if (event.row) {
			this.dataService.clearReplacementPODetails();
			const clickedRow = event.row;
			const poNumber = clickedRow[this.configService.poNumberProp];
			const supplierId = clickedRow[this.configService.supplierIdProp];
			this.openPO(poNumber, supplierId);
		}
	}

	tableSelect(event) {
		console.log('PO TABLE SELECT: ', event);
		// for some reason this.dataService.selectedTableRows is not updated by select all
		this.dataService.selectedTableRows = event.selected;
	}

	tableRefresh(event) {
		console.log('PO TABLE REFRESH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadPOsForTab(activeTab);
	}

	tablePage(event) {
		console.log('PO TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.getActiveTab(this.tabsData.listTabs)['page'] = event.offset;
		this.loadPOsForTab(activeTab);
	}

	tableSort(event) {
		this.dataTableService.tableSort(event, this.getActiveTab(this.tabsData.listTabs), (tab) => this.loadPOsForTab(tab));
	}

	tableSearch(event) {
		console.log('PO TABLE SEARCH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadPOsForTab(activeTab);
	}

	selectLoadedContractor(contractorDetails) {
		console.log('SELECT LOADED CONTRACTOR', contractorDetails);
		const self = this;
		if (contractorDetails !== null) {
			// make sure the selected row in the table matches the loaded contractor
			// no matter the methods by which it was loaded
			// first set data to loop to proper list from contractor list tab selection
			let data = this.dataService.poPendingContractors;
			if (this.contractorService.getActiveTab(this.contractorService.tabsData.listTabs)['prop'] === 'all') {
				console.log('ALL PO CONTRACTORS');
				data = this.dataService.poContractors;
			}
			data.forEach(function (d, i) {
				if (d[self.configService.contractorIdProp] === contractorDetails[self.configService.contractorIdProp]) {
					console.log('MATCHED CONTRACTOR', d);
					self.dataService.selectedTableRows = [d];
				}
			});
		}
	}

	poContractorsTableClick(event) {
		console.log('PO CONT TABLE CLICK: ', event);
		const clickedRow = event.row;
		const poNumber = clickedRow.ponumber;
		const contractorId = clickedRow[this.configService.contractorIdProp];
		const poConnector = clickedRow[this.configService.contractorLineItemProp];
		const supplierId = clickedRow[this.configService.supplierIdProp];
		const prop = 'uuid';
		const config = this.configService.getDataObj(this.configService.contractorDataObj);
		this.openPOContractor(poNumber, contractorId, supplierId);
		// this.showAvailableContractor(uuid, prop, config);
		// this.activeTab = this.tabsData.tabs[1];
		this.activePanels = '';
		const self = this;
		let matchedContractor = -1;
		this.dataService.availableContractors.forEach(function (d, i) {
			if (d[self.configService.uuidProp] === poConnector) {
				matchedContractor = i;
			}
		});
		if (matchedContractor > -1) {
			this.activePanels = 'panel-' + matchedContractor;
		}
		console.log('PO SERVICE ACTIVE PANELS', this.activePanels, this.dataService.selectedTableRows);
	}

	showAvailableContractor(data, prop, contractorConfig) {
		console.log('PO CONTRACTORS', this.dataService.poContractors);

		const self = this;
		let matchedContractor = -1;
		this.dataService.poContractors.forEach(function (d, i) {
			if (d[self.configService.poConnector] === data) {
				matchedContractor = i;
			}
		});

		if (matchedContractor > -1) {
			const poNumber = this.dataService.poContractors[matchedContractor][this.configService.poNumberProp];
			const contractorId = this.dataService.poContractors[matchedContractor][this.configService.contractorIdProp];
			const supplierId = this.dataService.poContractors[matchedContractor][this.configService.supplierIdProp];
			this.openPOContractor(poNumber, contractorId, supplierId);
		} else {
			this.populateNewContractor(data, prop, contractorConfig);
		}

		this.dataService.clearSelectedTableRows();
	}

	addPOContractor(data) {
		const prop = this.configService.uuidProp;
		const contractorConfig = this.configService.getDataObj(this.configService.contractorDataObj);
		this.populateNewContractor(data, prop, contractorConfig);
		this.dataService.clearSelectedTableRows();
	}

	// AUTOMATED PROCESSES

	getActivePanels() {
		return this.activePanels;
	}

	populateNewContractor(data, prop, contractorConfig) {
		console.log('POP NEW CONTRACTOR CONFIG', contractorConfig);
		this.dataService.clearContractorNodes();
		/*
		Set object for new contractor auto pop fields
		PO data is currently loaded PO
		Contractor data is pulled out of PO items array to match unique data from clicked available contractor
		*/
		const newContractorPOData = this.dataService.poDetails;
		const newContractorContractorData = this.dataService.getAvailableContractor(data, prop);
		console.log('NEW CONTRACTOR AUTOPOP REF', newContractorPOData, newContractorContractorData);

		const newContractorData = {};
		const self = this;

		contractorConfig.fields.forEach(function (d, i) {
			// console.log('NEW CONTRACTOR FIELD:', d.prop);

			// Use autoPop from config files to grab from po data or po contractor item
			if (d.autoPop === '') {
				newContractorData[d.prop] = '';
			} else {
				const popArr = d.autoPop.split(':');
				if (popArr[2] === undefined) {
					newContractorData[d.prop] = newContractorPOData[popArr[1]];
				}
				if (popArr[2] !== undefined && popArr[3] === undefined) {
					newContractorData[d.prop] = newContractorContractorData[popArr[2]];
				}
				if (popArr[3] !== undefined) {
					newContractorData[d.prop] = newContractorContractorData[popArr[2]][popArr[3]];
				}
			}

			// check & fix empty boolean values
			if (d['validate'] === self.configService.validateBooleanProp) {
				if (newContractorData[d['prop']] === undefined || newContractorData[d['prop']] === '') {
					newContractorData[d['prop']] = false;
				} else {
					if (newContractorData[d['prop']] === true || newContractorData[d['prop']] === 'true') {
						newContractorData[d['prop']] = true;
					} else {
						newContractorData[d['prop']] = false;
					}
				}
				console.log('FIXED BOOLEAN', d['prop'], d['validate'], newContractorData[d['prop']]);
			}

		});

		// initialize flexifields
		contractorConfig.objects.forEach(function (d, i) {
			if (d.prop === self.configService.contractorAddonsProp) {
				newContractorData[self.configService.contractorAddonsProp] = {};
				d.fields.forEach(function (dd, ii) {
					newContractorData[self.configService.contractorAddonsProp][dd.prop] = '';
				});
			}
		});

		// set ilcenabled as true by default
		newContractorData[this.configService.contractorILCProp] = true;

		const aclData = newContractorData;
		const aclPersonas = this.configService.personas;
		const aclConfig = this.configService.getDataObj(this.dataObj).fields;
		const aclService = this.configService;
		let newContractorDetails = this.dataService.showACL(aclData, aclPersonas, aclConfig, aclService);
		// need populate countrycode
		newContractorDetails[this.configService.countryCodeProp] = this.dataService.poDetails[this.configService.countryCodeProp];
		newContractorDetails = this.contractorService.updateContractorByCountrycode(newContractorDetails);
		console.log('NEW CONTRACTOR DATA', newContractorDetails);
		this.dataService.updateNewContractorDetails(newContractorDetails);
	}

	viewReplacedPO() {
		// this.selectedPO = this.dataService.poDetails;
		// this.router.navigate(['/replacement']);
		this.dataService.updateReplacementPODetails(_.cloneDeep(this.dataService.poDetails));
		const poNumber = this.dataService.poDetails[this.configService.previousPOProp];
		const prePOSupplierId = this.dataService.poDetails[this.configService.prevPOSupplierIdProp];
		this.openPO(poNumber, prePOSupplierId);
	}

	viewReplacementPO() {
		const poNumber = this.dataService.replacementPODetails[this.configService.poNumberProp];
		const supplierId = this.dataService.replacementPODetails[this.configService.supplierIdProp];
		this.openPO(poNumber, supplierId);
		this.dataService.clearReplacementPODetails();
		console.log('REPLACEMENT PO DETAILS', this.dataService.replacementPODetails);
	}

	private _retrieveContractorNames(contractors, ponumber) {
		if (!contractors && !Array.isArray(contractors)) {
			return '';
		}
		const names = [];
		for (let i = 0; i < contractors.length; i++) {
			if (contractors[i].contractorname && contractors[i].contractorid.startsWith(ponumber)) {
				names.push(contractors[i].contractorname);
			}
		}

		return names;
	}

	retireveEmailFromPO(po, persona) {
		const email = po.acl[persona].participants && po.acl[persona].participants.length > 0
			? po.acl[persona].participants[0] : '';
		return email;
	}

	//
	// API CALLS
	//

	loadPO(poNumber, supplierId, andExtras = false) {
		const self = this;
		this.dataService.updatePODetails(null);

		this.displayService.startLoading();
		this.commsService.getPODetails(poNumber, supplierId).subscribe((res) => {
			const successData = self.commsService.getSuccessData(res);
			// hide item fields if no unit price only for US
			if (successData.items && successData[this.configService.countryCodeProp] === this.configService.countryCodes.US) {
				successData.items.forEach(item => {
					item = this._hideFieldsIfNoUT(item);
				});
			}

			self.selectDefaultTab(self.tabsData.tabs);
			self._updateDataService(successData);

			// SUBSEQUENT ACTIONS
			if (andExtras) {
				if (successData.renewalpo) {
					// if prevponum === '', UI wont call API to return all contractors
					// since it could hang in the production with the large set of the contractors
					if (successData.prevponum && successData.prevponum.length > 0) {
						self.contractorService.loadPOContractors(successData.prevponum, this.contractorService.getPOAllTab(), true, true);
					}
				}
				// contractor tabs are only on PO Details page
				// andExtras should only be true coming from PO Details page
				self.contractorService.selectDefaultTab(self.contractorService.tabsData.tabs);
				self.contractorService.selectDefaultTab(self.contractorService.tabsData.poListTabs);
			}

			self.displayService.endLoading();
		}, (err) => {
			self.commsService.handleAPIError('Load PO', err);
			const persona = self.configService.persona.toLowerCase();
			if (persona !== self.configService.personaProps.contractor) {
				self.router.navigateByUrl(this.listRoot);
			}
			self.displayService.endLoading();
		});
	}

	_updateDataService(successData) {
		this.dataService.updatePODetails(successData);
		this.dataService.updateMinMaxDates();
	}

	_hideFieldsIfNoUT(item) {
		this._hideFields(item.straighttime);
		this._hideFields(item.overtime);
		this._hideFields(item.doubletime);
		this._hideFields(item.expense);
		if (item.lines) {
			Object.keys(item.lines).forEach(key => {
				this._hideFields(item.lines[key]);
			});
		}
	}

	_hideFields(item) {
		if (item && !item.unitprice) {
			const keys = Object.keys(item);
			keys.forEach(key => {
				item[key] = '';
			});
		}
	}

	loadPOs(data, loadAll = false) {
		const self = this;
		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.listTabs);
		}
		this.commsService.getPOList(data, loadAll).subscribe((res) => {
			console.log('LOAD POS RES: ', res);
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}
			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			const POs = [];
			successData.forEach((d) => {
				self._parsePO(d);
				POs.push(d);
			});
			if (!loadAll) {
				const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, POs);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(POs);	// this will trigger to export POs to csv
			}
		}, (err) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}
			self.commsService.handleAPIError('Load POs', err);
		});
	}

	downloadPOsForTab(tab) {
		this.commsService.downloadPOsForTab(tab).subscribe((res) => {
			console.log('DOWNLOAD POS RES: ', res);
			this.commsService.saveToCSV(tab.filename, res);
		}, (err) => {
			this.commsService.handleAPIError('Download POs', err);
		});
	}
	_parsePO(po) {
		po['contractors'] = this._retrieveContractorNames(po['contractors'], po['ponumber']);
		po = this._retrieveSTRemainingFunds(po);
		po['pmemail'] = po.acl.pm.participants && po.acl.pm.participants.length > 0
			? po.acl.pm.participants[0] :
			'';
		this._retrieveStartEndDates(po);
	}

	_retrieveStartEndDates(po) {
		if (po[this.configService.poItems] && po[this.configService.poItems].length > 0) {
			po[this.configService.poItemsStartDate] = po[this.configService.poItems][0][this.configService.startDateProp];
			po[this.configService.poItemsEndDate] = po[this.configService.poItems][0][this.configService.endDateProp];
		} else {
			po[this.configService.poItemsStartDate] = '';
			po[this.configService.poItemsEndDate] = '';
		}
	}

	updatePOInvoiceCalendar(origin) {
		const self = this;
		const newCalendarId = this.dataService.poDetails[this.configService.calendarIdProp];
		const poNumber = this.dataService.poDetails[this.configService.poNumberProp];
		const supplierId = this.dataService.poDetails[this.configService.supplierIdProp];
		console.log('UPDATE PO INVOICE CALENDAR', poNumber, supplierId, newCalendarId);

		this.displayService.startLoading();
		this.commsService.sendPOInvoiceCalendar(poNumber, supplierId, newCalendarId).subscribe((res) => {
			self.displayService.endLoading();
			origin.calendarUpdateSuccess();

		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('Update PO Invoice Calendar', err);
		});
	}

	_retrieveSTRemainingFunds(PO) {
		const items = PO[this.configService.poLineItemsProp];
		items.map(item => {
			if (item.straighttime && !item.straighttime.remainingpercent) {
				item.straighttime.remainingpercent = 0;
			}
			if (item.lines && item.lines[this.straighttimeKey] && !item.lines[this.straighttimeKey]['remainingpercent']) {
				item.lines[this.straighttimeKey]['remainingpercent'] = 0;
			}
		});
		PO[this.configService.poLineItemsProp] = items;

		if (!items || items.length === 0) {
			PO['remainingSTPercentage'] = '';
			PO['remainingSTQuantity'] = '';
		} else if (items[0].straighttime) {
			PO['remainingSTPercentage'] = items[0].straighttime.remainingpercent;
			PO['remainingSTQuantity'] = items[0].straighttime.remainingquantity;
		} else if (items[0].lines && items[0].lines[this.straighttimeKey]) {
			PO['remainingSTPercentage'] = items[0].lines[this.straighttimeKey]['remainingpercent'];
			PO['remainingSTQuantity'] = items[0].lines[this.straighttimeKey]['remainingquantity'];
		} else {
			PO['remainingSTPercentage'] = '';
			PO['remainingSTQuantity'] = '';
		}

		return PO;
	}

	submitPO(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.sendPO(data).subscribe((res) => {
			self.displayService.endLoading();
			console.log('SUBMIT PO RES', res);
			self.noteService.displaySuccess('The purchase order has been submitted successfully.');
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Submit PO', err);
		});
	}

	loadPOContractor(poNumber, contractorId, supplierId) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.getContractorDetails(poNumber, contractorId, supplierId).subscribe((res) => {
			self.displayService.endLoading();
			console.log('LOAD PO CONTRACTOR RES: ', res);

			let successData = self.commsService.getSuccessData(res);
			// API /getcontractor will returns the empty accounts array in contractor json after
			// supporting ilc search
			// const contractorNodes = self.accountService.nodesFromAccounts(successData[self.configService.accountsProp]);
			successData = self.contractorService.parseApprovalDate(successData);
			const aclData = self.contractorService.parseEmails(successData);
			const aclPersonas = self.configService.personas;
			const aclConfig = self.configService.getDataObj(self.dataObj).fields;
			const aclService = self.configService;
			let contractorDetails = self.dataService.showACL(aclData, aclPersonas, aclConfig, aclService);
			contractorDetails = self.contractorService.fillAddonFields(contractorDetails);
			contractorDetails = self.contractorService.updateContractorByCountrycode(contractorDetails);
			// self.dataService.updatePOContractorDetails(contractorDetails, contractorNodes);
			self.dataService.updatePOContractorDetails(contractorDetails);
			self.selectLoadedContractor(contractorDetails);
			self.dataService.broadcastPOContractor();

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Load PO Contractor', err);
		});
	}

	mergeContractor(removeData, newData, origin) {
		const self = this;

		const data = {};
		data[this.configService.contractorMergeProp] = newData;
		data[this.configService.contractorDeleteProp] = removeData;
		self.dataService.poContractorDetails = newData;

		this.displayService.startLoading();
		this.commsService.mergeContractor(data).subscribe((res) => {
			self.displayService.endLoading();
			console.log('MERGE CONTRACTOR RES: ', res);

			// SUBSEQUENT ACTIONS
			origin.contractorSuccess();

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Merge PO Contractors', err);
		});
	}

	isPOCancelled() {
		let cancelled = false;
		if (this.dataService['poDetails'] && this.dataService['poDetails']['cancellation']) {
			cancelled = true;
		}

		return cancelled;
	}

	handlePartialSuccess(res) {
		this.showErrorPOs = true;
		this.showSuccessPOs = false;
		const error = res.error;

		this.configService.resetTempTab();
		const tempTab = this.configService.tempTab;

		const errorRes = this.commsService.getPartialError(error);
		const errorCount = this.commsService.getSuccessCount(errorRes);
		const errorDataRef = this.errorDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(errorDataRef, tempTab, errorRes);
		this.dataService.updateDataCount(errorDataRef, errorCount);

		const successRes = this.commsService.getPartialSuccess(error);
		const successCount = this.commsService.getSuccessCount(successRes);
		const successDataRef = this.successDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(successDataRef, tempTab, successRes);
		this.dataService.updateDataCount(successDataRef, successCount);

		if (this.dataService.pageData[successDataRef][0].length > 0) {
			this.showSuccessPOs = true;
		}
		console.log('PARITAL SUCCESS PURCHASE ORDERS', this.dataService.pageData[errorDataRef][0], this.dataService.pageData[successDataRef][0]);
	}

	closePartialSucessModal(event) {
		this.showErrorPOs = false;
		this.showSuccessPOs = false;
	}
}
